const formatDate = require('../../../common/utility/date-formatter');
const CollectionTimeService = function (storePickerService) {
    this.storePickerService = storePickerService;
};

CollectionTimeService.prototype.calculateBackorderPickupDate = function () {

    if (this.storePickerService.fulfilmentInfo &&
        this.storePickerService.fulfilmentInfo.ClickAndCollectDetails &&
        this.storePickerService.fulfilmentInfo.ClickAndCollectDetails.BackOrderFulfilmentDate) {
        return formatDate(this.storePickerService.fulfilmentInfo.ClickAndCollectDetails.BackOrderFulfilmentDate);
    }

};


module.exports = CollectionTimeService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collection-time-switch/collection-time-service.js
 **/